import React from 'react';
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import RadioSelectForm from 'components/molecules/RadioSelectForm';

const FaceRegistrationStatusRadio: React.FC<{
  faceRegistrationStatus: string;
  setFaceRegistrationStatus: (faceRegistrationStatus: string) => void;
}> = ({ faceRegistrationStatus, setFaceRegistrationStatus }) => (
  <FlexBox
    customStyle={css({
      padding: '8px',
    })}
  >
    <FlexBoxItem basis="10%">
      <BodyText> 顔写真 </BodyText>
    </FlexBoxItem>
    <FlexBoxItem basis="90%">
      <RadioSelectForm
        name="FacePhotoStatusRadio"
        items={[
          {
            value: '-1',
            label: 'すべて',
          },
          {
            value: '0',
            label: '未登録',
          },
          {
            value: '1',
            label: '登録済',
          }
        ]}
        value={faceRegistrationStatus}
        setValue={(e) => {
          setFaceRegistrationStatus(e.target.value);
        }}
      />
    </FlexBoxItem>
  </FlexBox>
);

export default FaceRegistrationStatusRadio;
